import { render, staticRenderFns } from "./CompaniaSeleccion.vue?vue&type=template&id=304a9c1e&"
import script from "./CompaniaSeleccion.vue?vue&type=script&lang=js&"
export * from "./CompaniaSeleccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports